/*
 * PDP COLLAPSIBLE CARD -- shared expand/collapse behaviour for "Buy It With" and
 * "Add free personalisation". Markup contract (see component-pdp-collapsible.css):
 *
 *   <div class="ev-collapsible" data-ev-collapsible [data-ev-collapsible-static]>
 *     <button class="ev-collapsible__head" data-ev-collapsible-toggle aria-expanded="false" aria-controls="X-body">...</button>
 *     <div class="ev-collapsible__body" id="X-body" data-ev-collapsible-body hidden>...</div>
 *   </div>
 *
 * Using a real <button> for the toggle means Enter/Space activation and focus states are native --
 * this file only needs to handle the click and the height/opacity animation. Content inside the
 * body is never removed from the DOM (only [hidden] is toggled), so checkbox/input state inside it
 * survives a collapse/expand cycle for free.
 */
(function () {
  if (window.evCollapsibleBound) return;
  window.evCollapsibleBound = true;

  function isStatic(card) {
    return card.hasAttribute('data-ev-collapsible-static');
  }

  function expand(card, body) {
    if (body._evTransitionCleanup) body._evTransitionCleanup();

    if (isStatic(card)) {
      body.hidden = false;
      return;
    }

    body.hidden = false;
    body.style.height = '0px';
    body.style.opacity = '0';

    var target = body.scrollHeight;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        body.style.height = target + 'px';
        body.style.opacity = '1';
      });
    });

    var onEnd = function (event) {
      if (event.target !== body || event.propertyName !== 'height') return;
      body.style.height = 'auto';
      cleanup();
    };
    var cleanup = function () {
      body.removeEventListener('transitionend', onEnd);
      body._evTransitionCleanup = null;
    };
    body._evTransitionCleanup = cleanup;
    body.addEventListener('transitionend', onEnd);
  }

  function collapse(card, body) {
    if (body._evTransitionCleanup) body._evTransitionCleanup();

    if (isStatic(card)) {
      body.hidden = true;
      return;
    }

    body.style.height = body.scrollHeight + 'px';
    body.style.opacity = '1';

    requestAnimationFrame(function () {
      body.style.height = '0px';
      body.style.opacity = '0';
    });

    var onEnd = function (event) {
      if (event.target !== body || event.propertyName !== 'height') return;
      body.hidden = true;
      body.style.height = '';
      body.style.opacity = '';
      cleanup();
    };
    var cleanup = function () {
      body.removeEventListener('transitionend', onEnd);
      body._evTransitionCleanup = null;
    };
    body._evTransitionCleanup = cleanup;
    body.addEventListener('transitionend', onEnd);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ev-collapsible-toggle]');
    if (!toggle) return;

    var card = toggle.closest('[data-ev-collapsible]');
    var body = card ? card.querySelector('[data-ev-collapsible-body]') : null;
    if (!body) return;

    var willOpen = body.hidden;
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    if (willOpen) {
      expand(card, body);
    } else {
      collapse(card, body);
    }
  });
})();
